<template>
    <el-dialog
      v-if="visible"
      title="发票记录"
      :visible.sync="visible"
      width="80%"
      :append-to-body="true"
      @close="closeDialog"
    >
          <avue-crud
            :option="option"
            :table-loading="loading"
            :data="data"
            :page.sync="page"
            ref="crud"
            @on-load="onLoad"
            @current-change="currentChange"
            @size-change="sizeChange"
            @refresh-change="onLoad"
          >
          </avue-crud>
    </el-dialog>

</template>
<script>


import {
  getPage,
} from "@/api/v4ward/digitaltickets/taxinvoicerecord/TaxInvoiceRecord";
import { getDictionary } from '@/api/common.js';

export default {
  components: {

  },
  props: {
    feePayId:'',
    communityId:'',
    businessSource:'',
    visible:false,
  },
  data() {
    return {
      data:[],
      option: {
        index: true,
        indexLabel: '序号',
        page: true,
        height: 'auto',
        calcHeight: 'auto',
        align: 'center',
        refreshBtn: false,
        viewBtn: false,
        searchBtn:false,
        columnBtn:false,
        searchShowBtn:false,
        menu: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        border: true,
        column: [
          {
            label: "发票记录编号",
            prop: "invoiceBillNo",
            width: 170,
          },
          {
            label: "发票号码",
            prop: "invoiceNo",
            width: 160,
          },
          {
            label: "所属小区",
            prop: "communityName",
            width: 110,
          },
          {
            label: "客户",
            prop: "customer",
            width: 110,
          },
          {
            label: "房号",
            prop: "roomName",
            width: 160,
            overHidden: true,
          },
          {
            label: "发票类型",
            prop: "invoiceTypeName",
            width: 110,
          },
          {
            label: "金额",
            prop: "payAmount",
          },
          {
            label: "发票标识",
            prop: "invoiceFlag",
            dicData: [
              { label: '红票', value: 'red' },
              { label: '蓝票', value: 'blue' },
            ],
          },
          {
            label: "红/蓝票号",
            prop: "invoiceNoLink",
            width: 160,
            overHidden: true,
          },
          {
            label: "开票人",
            prop: "invoiceUser",
          },
          {
            label: "开票时间",
            prop: "invoiceTime",
            width: 130,
          },
          {
            label: "开票状态",
            prop: "invoiceStatus",
            dicData: [
              { label: '进行中', value: '0' },
              { label: '开票成功', value: '1' },
              { label: '开票失败', value: '2' },
              { label: '已红冲', value: '3' },
              { label: '开票中', value: '4' },
            ],
          },
          {
            label: "开票失败原因",
            prop: "blueErrorMsg",
            width: 130,
            overHidden: true,
          },
          {
            label: "红冲原因",
            prop: "redReason",
            dicData:[],
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
          },
          {
            label: "红冲失败原因",
            prop: "redErrorMsg",
            width: 130,
            overHidden: true,
          },
          {
            label: "销售方信息",
            prop: "sellerName",
            width: 120,
            overHidden: true,
          },
          {
            label: "业务来源",
            prop: "businessSourceName",
            width: 100,
          },
          {
            label: "开票来源",
            prop: "issueSource",
            dicData: [
              { label: '管理平台', value: 'PC' },
              { label: '小程序', value: 'CLIENT' },
            ],
          },
        ]
      },
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      loading: false,
    };
  },
  watch:{
  },
  created() {
    getDictionary('invoice_red_reason').then((res) => {
      this.findObject(this.option.column,'redReason').dicData = res.data;
    });
  },
  methods: {
    closeDialog(){
      this.visible = false;
      this.$emit('close');
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad() {
      this.loading = true;
      if(this.feePayId){
        getPage(Object.assign({},{ current: this.page.currentPage, size: this.page.pageSize }
          , {targetIds:this.feePayId, communityId:this.communityId, businessSource:this.businessSource})).then(({data})=>{
          this.data = data.records
          this.page.total = data.total
          this.loading = false;
        }).catch(()=>{
          this.loading = false;
        })
      }
    },
  },
};
</script>
<style>

</style>
